const unitScale = {
  'in': 1,
  'mm': 25.4,
  'cm': 2.54,
  'ft': 1 / 12,
  'm': 0.0254,
}

export default unitScale